import { IPaymentEmailConfirmationHeader } from '../../store/interface';
import { API_ROUTES } from '../constants';
import utils from '../utils';

export interface IPaymentPersonalizationDetails {
  tagName: string;
  value: string;
}

interface IPaymentDetailsForEmailConfirmation {
  submitterMessageId: string;
  email: Array<string>;
  personalization: IPaymentPersonalizationDetails[];
}

const communication = () => ({
  sendPaymentDetailsEmailConfirmation: (
    data: IPaymentDetailsForEmailConfirmation,
    headers: IPaymentEmailConfirmationHeader,
  ) =>
    utils.fetch(API_ROUTES.communication.sendPaymentDetailsEmailConfirmation, {
      method: 'POST',
      data,
      headers: { ...headers },
    }),
});

export default communication;
